import React, { useState } from 'react';

import { Button } from '@eika/button';
import { SummaryCard } from '@eika/card';
import { AttentionLabel } from '@eika/label';
import { RichIconTypes } from '@eika/rich-icon';

import DemoModal from './components/DemoModal';

import './DemoLoanApplications.scss';

const DemoLoanApplication: React.FC = () => {
    const [openDemoModal, setOpenDemoModal] = useState(false);
    return (
        <SummaryCard icon={RichIconTypes.HUS_ENKELT} data-testid="demo-loan-application">
            <div className="demo-loan-applications">
                <AttentionLabel className="demo-loan-applications__label" text="Ny lånesøknad" />
                <p className="demo-loan-applications__description" data-testid="demo-loan-application-description">
                    Dere har fått tilbud om boliglån på
                </p>
                <span data-testid="demo-loan-application-amount" className="demo-loan-applications__amount bold">
                    5 000 000 kr
                </span>
                <section className="demo-loan-applications__action-wrapper">
                    <Button data-testid="demo-loan-application-signing-button" onClick={() => setOpenDemoModal(true)}>
                        Signér lånedokumenter
                    </Button>
                    <AttentionLabel text="Frist 16.05.2025" />
                </section>
            </div>
            <DemoModal open={openDemoModal} setOpen={setOpenDemoModal} />
        </SummaryCard>
    );
};

export default DemoLoanApplication;
